import { Model } from '@vuex-orm/core'

export default class LicensedPlan extends Model {
  static entity = 'licensedPlans'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      allowProjects: this.boolean(false),
      availableMemberType: this.string(''),
      contractType: this.string(''),
      isBillingExist: this.boolean(false),
      licenseExpiredAt: this.attr(null),
      licensePlanMasterId: this.attr(null),
      licenseStartAt: this.string(''),
      maxFileSize: this.number(0), // MB
      maxGroups: this.attr(null),
      maxStoreDuration: this.number(0), // Month
      maxUsers: this.number(0),
      planDescription: this.string(''),
      planName: this.string(''),
      planType: this.string(''),
      price: this.number(0),
      roomPlanMasters: this.attr([]),
      seatPlanMasters: this.attr([])
    }
  }

  get roomPlanMasterIds() {
    return this.roomPlanMasters.map((roomPlanMaster) => roomPlanMaster.roomPlanMasterId)
  }

  get seatPlanMasterIds() {
    return this.seatPlanMasters.map((seatPlanMaster) => seatPlanMaster.seatPlanMasterId)
  }

  get availableAddTemporaryGuest() {
    return this.availableMemberType.includes('TemporaryGuest')
  }
}
